var site = window.site || {};

(function ($) {
  Drupal.behaviors.productPartialV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-sku-brief-editorial', context);

      self.productPartialInit($modules);

      // For dynamically generated uses of this partial which get added to DOM after page load.
      $(document).on('product_partial:product_reinit', function (e) {
        var $el = e.payload['$el'];

        self.productPartialInit($el);
      });
    },
    productPartialInit: function ($modules) {
      var self = this;

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.setInits($module);
      });
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.link = $('.js-sku-brief-spp-link', $module);
      $module.nodes.shadeCarousel = $('.js-sku-brief-editorial-shade-container', $module);
      $module.nodes.swatches = $('.js-sku-brief-editorial-swatch-container', $module);
      $module.nodes.image = $('.js-sku-brief-editorial-image', $module);
      $module.nodes.shadeName = $('.js-sku-brief-editorial-shadename', $module);
      $module.nodes.size = $('.js-sku-brief-editorial-size', $module);
      $module.nodes.atb = $('.js-product-add-to-bag', $module);
    },
    getProps: function ($module) {
      $module.props = {};
    },
    setInits: function ($module) {
      var self = this;

      self.skuInits($module);
    },
    skuInits: function ($module) {
      var self = this;
      var $carousel = $module.nodes.shadeCarousel.find('.js-sku-brief-editorial-shade');
      var $sku;
      var skuStatus;
      var $shadeCarousel;

      $carousel.each(function () {
        $sku = $(this);
        skuStatus = $sku.data('inventoryStatus');
        if (['7', 'Sold Out', '3', 'Coming Soon', '2', 'Temporarily out of stock'].includes(skuStatus)) {
          $sku.addClass('unavailable');
        }
      });

      $carousel.first().addClass('active');
      $module.nodes.shadeCarousel.on('init', function () {
        self.setSkuListeners($module);
        $.event.trigger({
          type: 'product_partial:sku_slick_init',
          payload: {
            $el: $module.nodes.shadeCarousel
          }
        });
      });
      // Unslick if already slicked to prevent reinit errors.
      $module.nodes.shadeCarousel.each(function () {
        $shadeCarousel = $(this);
        if ($shadeCarousel.hasClass('slick-initialized')) {
          try {
            $shadeCarousel.slick('unslick');
          } catch (e) {
            console.error(e);
          }
        }
      });
      try {
        $module.nodes.shadeCarousel.slick({
          dots: false,
          arrows: true,
          infinite: false,
          slidesToScroll: 9,
          slidesToShow: 9,
          rtl: site.direction.isRTL,
          prevArrow:
            '<button class="sku-brief-editorial__shade-carousel-arrows slide-arrow slick-prev" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon--arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
          nextArrow:
            '<button class="sku-brief-editorial__shade-carousel-arrows slide-arrow slick-next" aria-label="Next" type="button" style="display: block;"><svg class="icon icon--arrow-left"><use xlink:href="#arrow-right"></use></svg></button>',
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToScroll: 8,
                slidesToShow: 8
              }
            }
          ]
        });
      } catch (e) {
        console.error(e);
      }
    },
    updateProduct: function ($module, $sku) {
      var imageUrl = $sku.data('productSkuMediumImg');
      var shadeName = $sku.data('productShadename');
      var productId = $sku.data('productId');
      var skuId = $sku.data('productSkuBaseId');
      var size = $sku.data('productSize');
      var skuStatus = $sku.data('inventoryStatus');
      var link = $sku.data('productLink');

      $module.nodes.link.attr('href', link + '?shade=' + shadeName);
      $module.nodes.shadeName.html(shadeName);
      $module.nodes.size.html(size);
      $module.nodes.image.attr('src', imageUrl);
      $module.nodes.atb.attr('data-sku-base-id', skuId);
      $module.nodes.atb.attr('data-product-id', productId);
      $module.nodes.atb.attr('data-inventory-status', skuStatus);

      $.event.trigger({
        type: 'product_partial:atb_status_change',
        payload: {
          $el: $module.find('.js-product-add-to-bag-wrapper'),
          $currentSku: $sku,
          status: skuStatus
        }
      });
    },
    setSkuListeners: function ($module) {
      var self = this;
      var $carousel = $module.nodes.shadeCarousel.find('.js-sku-brief-editorial-shade');

      $carousel.each(function () {
        var $currentSku = $(this);

        $currentSku.off('click').on('click', function () {
          $carousel.removeClass('active');
          $currentSku.addClass('active');
          self.updateProduct($module, $currentSku);
        });
      });
    }
  };
})(jQuery);
